export const platformVersion = '^17.0.0';
